import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import style from './style.module.css';

import Loader from '../../../assets/images/loader.svg';

import { Language, getLanguageArray, systemLanguage, getToken, getUuid, nl, falseEmailsContentItemLabel, getLabel, setUserActivityData, setUserContData, getUserPoints, setUserPoints, setUserLevel } from '../../../utils/constants';
import { getFakeEmailArticle } from '../../../services/cmsApi';
import { createActivity } from '../../../services/activityApi';

import { useNotification } from '../../../utils/notifications';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';

const EmailsPageView: React.FC = () => {

  const { article_uuid } = useParams();

  const userToken = getToken()
  const userUuid = getUuid() 

  const notify = useNotification();

  const [loading, setLoading] = useState(true);
  const [article, setArticle] = useState<any | boolean>(false);
  const [sessionLang, setSessionLang] = useState<Language>(getLanguageArray());

  const fetchArticle = async (article_uuid: string) => {
    setLoading(true);
    const response = await getFakeEmailArticle({ uuid: userUuid, token: userToken, article_uuid: article_uuid });
    setArticle(response.page || []);
    setLoading(false);

    let activityLabel = 'read_warning_email_article_' + response.page.id
    createActivityStream(activityLabel)
  };


  const createActivityStream = async(activityLabel: string, notificationText: string = "Experience Points Gained!", show: boolean = true) => {
      let createActivityReq = await createActivity({
          uuid: userUuid,
          token: userToken,
          user_uuid: userUuid,
          activity_label: activityLabel
      })
  
      if(createActivityReq.activity){
        setUserActivityData(JSON.stringify(createActivityReq.activity))
        setUserContData(JSON.stringify(createActivityReq.activity_chart))
      }
              
      if(createActivityReq.exp === 0){
        return;
      }
  
      let userPoints = getUserPoints()
      let newUserPoints = userPoints + createActivityReq.exp
      setUserPoints(newUserPoints)
      setUserLevel(createActivityReq.level)
  
      if(show){
        notify(
          <>
            <FontAwesomeIcon icon={faBolt} /> <span>+{createActivityReq.exp} {notificationText}</span>
          </>
        )
      }
  }

  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === systemLanguage && e.newValue) {
        setSessionLang(JSON.parse(e.newValue));
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  useEffect(() => {
    fetchArticle(article_uuid ?? '');
  }, [article_uuid]);


  window.scroll(0,0)

  return (
    <div className={style.falseEmails}>
      <div className={style.header}>
        <div className={`${style.greeting} ${style.textContainerGrad}`}>
          {!loading ? article.title[nl] : ''}
        </div>
        <div className={style.info}>
          {getLabel(falseEmailsContentItemLabel, sessionLang)}
        </div>
        <div className={style.category}>
            <div className={style.block}>{!loading ? article.category : ''}</div><div className={style.date}>
                {/*!loading ? article.date : ''*/}
            </div>
        </div>
      </div>

      <div className={style.collection}>
        {loading ? (
          <div className={style.loader}>
            <img src={Loader} alt="Loading" />
          </div>
        ) : !article.uuid ? (
          <div className={style.noArticles}>404 - No article found</div>
        ) : (

              <div className={style.articleBody}>
                <div className={style.articleBodyLeft}>
                  {Array.isArray(article.content?.[nl]) &&
                    article.content[nl].map((block: { type: string; content: string[] }, bIdx: number) => (
                      <div key={bIdx}>
                        {Array.isArray(block.content) &&
                          block.content.map((line: string, i: number) => (
                            <p key={`${bIdx}-${i}`}>{line}</p>
                          ))}
                      </div>
                    ))
                  }
                  </div><div className={style.articleBodyRight}>
                    <div className={style.articleLogo}>
                      <img src={process.env.REACT_APP_CDN_URL + '/' + article.logo} />
                    </div>
                    <div className={style.articleEmail}>
                      <a href={process.env.REACT_APP_CDN_URL + '/' + article.email_image} target="_blank">
                        <img src={process.env.REACT_APP_CDN_URL + '/' + article.email_image} />
                      </a>
                    </div>
                  </div>
              </div>
        
      )}

      </div>
    </div>
  );
};

export default EmailsPageView;
